module.exports = __webpack_public_path__ + "img/33-config-modelos-doc-lista.daf82ec3.png";